module.exports = __webpack_public_path__ + "images/ai-insights-disabled-5c282646.svg";